import React, { useEffect } from "react";
import { useApplicationContext } from "../../components/applicationComponents/context/applicationContext";
import GroupInformationComponent from "../../components/applicationComponents/groupInformation/groupInformationComponent";

export default function GroupInformationPage() {
  const { setHeaderText } = useApplicationContext();
  useEffect(() => {
    setHeaderText({
      value: "Edit Group Information",
      icon: "view-app-icon icon-spec mr-3 mt-0",
    });
  }, []);

  return (
    <>
      <div className="flex flex-col align-items-start w-full height-calc">
        <GroupInformationComponent disabled={false} />
      </div>
    </>
  );
}
